import React, { useState } from 'react';
import ReactPlayer from 'react-player';
import { makeStyles } from '@material-ui/core/styles';
import clsx from 'clsx';

interface OwnProps {
  src: string;
  alt?: string;
  width?: string;
  controls?: boolean;
  className?: string;
}

const useStyles = makeStyles((theme) => ({
  video: {
    position: 'relative',
    height: 'none !important',
    width: 'none !important',
    '& iframe, video': {
      width: '100% !important',
      height: 'auto !important',
      margin: '0 auto !important',
      display: 'block !important',
      maxWidth: '500px !important',
    },
  },
}));

const ImageOrVideo: React.FC<OwnProps> = (props) => {
  const { src, alt, width, controls = true, className } = props;
  const styles = useStyles();

  const [isCanPlay, setIsCanPlay] = useState(false);

  if (isCanPlay) {
    return (
      <ReactPlayer
        className={clsx(className, styles.video)}
        width={width || '100%'}
        height="auto"
        controls={controls}
        url={src}
      />
    );
  }

  return (
    <img
      className={className}
      width={width}
      src={src}
      alt={alt}
      onError={() => setIsCanPlay(true)}
    />
  );
};

export default ImageOrVideo;
